import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Prestador } from '../base/vo/prestador';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RequestOptions } from '@angular/http';
import { environment } from '../../../environments/environment';
import { BaseService } from '../base/util/base.service';
import { DadosPrestadorService } from './dados-prestador.service';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-dados-prestador',
  templateUrl: './dados-prestador.component.html',
  styleUrls: ['./dados-prestador.component.css']
})

export class DadosPrestadorComponent implements OnInit {

  constructor(public dadosPrestadorService: DadosPrestadorService, 
		public router: Router, 
		private route: ActivatedRoute, 
		public http: HttpClient, 
		public autenticacaoService: AutenticacaoService) { }

  dadosPrestador: Prestador = new Prestador();
  loading: boolean = false;
  exibeModalAlterarSenha: boolean = false;

  ngOnInit() {
    this.BuscarDados();
  }

  BuscarDados() {
  	this.loading = true;
    this.dadosPrestadorService.buscarDadosCadastrais().subscribe(
      data => {
        this.loading = false;
        this.dadosPrestador = data.data;
      },
      erro => {
      	this.loading = false;
      });
  }
  
  alterarSenha(){
    this.exibeModalAlterarSenha = true;
  }
  
  getLabelCpfCnpj () {
  	if(this.dadosPrestador && this.dadosPrestador.cnpj && this.dadosPrestador.cnpj.length > 11) {
  		return "CNPJ";
  	} else {
  		return "CPF";
  	}
  }
  
  isClinica():boolean {
  	return this.autenticacaoService.isClinica;
  }

} 


// WEBPACK FOOTER //
// ./src/app/components/dados-prestador/dados-prestador.component.ts